
import React from 'react'
import "./Categories.css"
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
function Categories({categoriesItems}) {
        const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
<div className='mb-5 best_selling_container'>
  <Container>
                    <div className="d-flex justify-content-between">
                    {/* <p className='fw-bold fs-5'>{currentLocal.home.categories}</p> */}
                </div>
  <div className='cat_container'>
                {categoriesItems?.map((item,index)=>{
                return(
<Link className='mx-2 mb-2'to={`/collections/${item?.id}`}>
  <img src={item?.image}alt=''className='cat_image'/>
  <p className='fs-6'>{currentLocal.language=="English"?item?.name_en:item?.name_ar}</p>
</Link>
                )})}

</div>

  </Container>
    </div>
  )
}

export default Categories
// import React from 'react'
// import "./Categories.css"
// import { Col, Container, Row } from "react-bootstrap";
// import { useSelector } from 'react-redux';
// import { Link } from 'react-router-dom';

// function Categories({categoriesItems}) {
      // const { currentLocal } = useSelector((state) => state.currentLocal);

//   return (
//       <div className='mb-5 best_selling_container'>
//             <Container>
                // <di className="d-flex justify-content-between">
                //     <p className='fw-bold fs-5'>{currentLocal.home.categories}</p>
                // </di>
//        <Container>
//         <Row>
            // {categoriesItems?.map((item,index)=>{
            //     return(
//                     <Col md={2}key={index}>
{/* <Link className='mx-2 mb-2'to={`/collections/${item?.id}`}>
  <img src={item?.image}alt=''className='cat_image'/>
  <p className='fs-6'>{currentLocal.language=="English"?item?.name_en:item?.name_ar}</p>
</Link> */}

//                                             </Col>
//                 )
//             })}
//         </Row>
//        </Container>
//                 {/* <Row>
//                     <Col md={3}>
//                         <ProductItem
//                             img={"https://smileheavenglow.com/images/products/Herbal%20Renewal%20Face%20Serum.jpg"}
//                             title={"Marshmallow Butter"}
//                             price={"150 EGP"}
//                         />
//                     </Col>
//                     <Col md={3}>
//                         <ProductItem
//                             img={"https://smileheavenglow.com/images/products/Marshmallow%20Butter.jpg"}
//                             title={"Herbal Renewal Face Serum"}
//                             price={"250 EGP"}
//                         />
//                     </Col>
//                     <Col md={3}>
//                         <ProductItem
//                             img={"https://smileheavenglow.com/images/products/Herbal%20Renewal%20Face%20Serum.jpg"}
//                             title={"Marshmallow Butter"}
//                             price={"150 EGP"}

//                         />
//                     </Col>
//                     <Col md={3}>
//                         <ProductItem
//                             img={"https://smileheavenglow.com/images/products/Marshmallow%20Butter.jpg"}
//                             title={"Herbal Renewal Face Serum"}
//                             price={"250 EGP"}

//                         />
//                     </Col>
//                     <Col md={3}>
//                         <ProductItem
//                             img={"https://smileheavenglow.com/images/products/Herbal%20Renewal%20Face%20Serum.jpg"}
//                             title={"Marshmallow Butter"}
//                             price={"150 EGP"}

//                         />
//                     </Col>
//                     <Col md={3}>
//                         <ProductItem
//                             img={"https://smileheavenglow.com/images/products/Marshmallow%20Butter.jpg"}
//                             title={"Herbal Renewal Face Serum"}
//                             price={"250 EGP"}

//                         />
//                     </Col>
//                     <Col md={3}>
//                         <ProductItem
//                             img={"https://smileheavenglow.com/images/products/Herbal%20Renewal%20Face%20Serum.jpg"}
//                             title={"Marshmallow Butter"}
//                             price={"150 EGP"}

//                         />
//                     </Col>
//                     <Col md={3}>
//                         <ProductItem
//                             img={"https://smileheavenglow.com/images/products/Marshmallow%20Butter.jpg"}
//                             title={"Herbal Renewal Face Serum"}
//                             price={"250 EGP"}

//                         />
//                     </Col>
//                 </Row> */}
//             </Container>
//         </div>  )
// }

// export default Categories

